"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var AnalyticsPeriod = (0, _keyMirror.default)({
  WEEKLY: null,
  MONTHLY: null,
  THIRTY_DAY: null
});
var _default = AnalyticsPeriod;
exports.default = _default;
module.exports = exports.default;